document.addEventListener('DOMContentLoaded', () => {

  const footers = document.querySelectorAll('.nxa-component-footer');

  const mediaQuery = window.matchMedia('(min-width: 992px)');

  footers.forEach(footer => {

    footer.querySelectorAll('.menu-item-has-children').forEach(item => {

      const button = item.querySelector(':scope > button');
      const body = item.querySelector(':scope > nav') || item.querySelector(':scope > .submenu-inner');

      if (!button || !body) {
        return;
      }

      let isAnimating = false;

      button.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!isAnimating) {
            toggleAccordion(button, body);
          }
        }
      });

      button.addEventListener('click', () => {
        if (!isAnimating) {
          toggleAccordion(button, body);
        }
      });

      function toggleAccordion(header, body) {

        if (mediaQuery.matches) {
          return;
        }

        if (header.getAttribute('aria-expanded') === 'true') {
          // open => close
          isAnimating = true;
          header.setAttribute('aria-expanded', 'false');
          body.style.maxHeight = `${body.scrollHeight}px`;
          requestAnimationFrame(() => {
            body.style.maxHeight = '0';
            body.style.opacity = '0';
            body.style.overflow = 'hidden';
          });
          body.addEventListener('transitionend', () => {
            body.style.maxHeight = '';
            body.style.opacity = '';
            body.style.overflow = '';
            isAnimating = false;
            body.classList.add('collapsed');
          }, {once: true});
        } else {
          // close => open
          isAnimating = true;
          body.classList.remove('collapsed');
          header.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = '0';
          body.style.opacity = '0';
          body.style.overflow = 'hidden';
          requestAnimationFrame(() => {
            body.style.maxHeight = `${body.scrollHeight}px`;
            body.style.opacity = '1';
          });
          body.addEventListener('transitionend', () => {
            body.style.maxHeight = '';
            body.style.opacity = '';
            body.style.overflow = '';
            isAnimating = false;
          }, {once: true});
        }
      }

    });

  });

});
